import { Component } from '@angular/core';

@Component({
  selector: 'ui-flex-item',
  templateUrl: './flex-item.component.html'
})
export class FlexItemComponent {
}